/**
 * @generated SignedSource<<7225bcc710686f33336a82f9e617c6e4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type duplicateDialogSalesChannelsQuery$variables = Record<PropertyKey, never>;
export type duplicateDialogSalesChannelsQuery$data = {
  readonly salesChannels: ReadonlyArray<{
    readonly detail: {
      readonly properties: {
        readonly name: string | null;
      } | null;
    } | null;
    readonly ecommerceSettings: {
      readonly ecommerceName: ECommerce;
      readonly hasProductsApi: boolean;
      readonly remoteUrl: string | null;
    } | null;
    readonly id: string;
  }>;
};
export type duplicateDialogSalesChannelsQuery = {
  response: duplicateDialogSalesChannelsQuery$data;
  variables: duplicateDialogSalesChannelsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "ignoreNoneECommerce",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "status",
    "value": "ACTIVE"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannelDetailProperties",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasProductsApi",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "duplicateDialogSalesChannelsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "SalesChannel",
        "kind": "LinkedField",
        "name": "salesChannels",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesChannelDetail",
            "kind": "LinkedField",
            "name": "detail",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "salesChannels(ignoreNoneECommerce:true,status:\"ACTIVE\")"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "duplicateDialogSalesChannelsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "SalesChannel",
        "kind": "LinkedField",
        "name": "salesChannels",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesChannelDetail",
            "kind": "LinkedField",
            "name": "detail",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v1/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v1/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "salesChannels(ignoreNoneECommerce:true,status:\"ACTIVE\")"
      }
    ]
  },
  "params": {
    "cacheID": "263bfacfb2d3f86f1f924847b7503ab7",
    "id": null,
    "metadata": {},
    "name": "duplicateDialogSalesChannelsQuery",
    "operationKind": "query",
    "text": "query duplicateDialogSalesChannelsQuery {\n  salesChannels(status: ACTIVE, ignoreNoneECommerce: true) {\n    id\n    detail {\n      properties {\n        name\n      }\n      id\n    }\n    ecommerceSettings {\n      ecommerceName\n      remoteUrl\n      hasProductsApi\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "de0bf0698c3a63309f8e8189a0c924b5";

export default node;
